module.exports = __webpack_public_path__ + "static/community-ce1e4d199ece70342b570e296ce2be06.svg";